export const colors = [
	'#aeea00',
	'#c51162',
	'#00bfa5',
	'#64dd17',
	'#ffab00',
]

export const backgroundColor = colors

export const hoverBackgroundColor = colors



// WEBPACK FOOTER //
// ./src/components/common/charts/colors.js